import req from './request.js'

export function rechargeTemp(data) {
  return req('get', '/api/recharge/getRecharge', data)
}

export function getVipPackages(data) {
  return req('get', '/api/recharge/getVipPackages', data)
}

// export function buy(data) {
//   return req('post', '/api/recharge/buy', data)
// }
export function buy(data) {
  return req('post', '/api/thpay/buy', data)
}
export function buyVip(data) {
  return req('post', '/api/thpay/buyVip', data)
}

export function checkPayOrder(data) {
  return req('get', '/api/thpay/checkPayOrder', data)
}

export function getPayInfoOrder(data) {
  return req('get', '/api/thpay/getPayInfoOrder', data)
}